module.exports = __webpack_public_path__ + "img/integral.e7274b6a.png";